import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-layout',
  template: `
    <div>
    <p-messages [(value)]="msgs"></p-messages>
    <router-outlet></router-outlet>
  </div>
  `,
  styles: []
})
export class LoginLayoutComponent { }



// WEBPACK FOOTER //
// ./src/app/components/layouts/login.layout.ts